import {Accordion} from "react-bootstrap";
import {useState} from "react";

const ExplanationNote = (props) =>{
      const [isActive, setIsActive] = useState(false);
    return(
        <div className="accordion-item" style={{fontSize: "0.1em", backgroundColor:"transparent", border: 0}}>
          <div className="accordion-title" onClick={() => setIsActive(!isActive)}>
              <div style={{display: "flex", justifyContent: "center", color:"#4c6262"}}><div style={{paddingRight:"2em"}}>{isActive ? '-' : '+'}</div><div>{props.data[0]}</div></div>
          </div>
          {isActive && <div className="accordion-content" style={{paddingLeft:"1vw", textAlign:"left"}}>{props.data[1]}</div>}
        </div>
    )
}

export default ExplanationNote;